import { Link } from "react-router-dom";

export default function DataDeletion() {
  const subject = encodeURIComponent("Demande de suppression de données — Mon Assistant Pro");
  const body = encodeURIComponent(
    "Bonjour,\n\nJe demande la suppression complète de mes données personnelles et de mes intégrations tierces (notamment Meta / Facebook / Instagram) liées à mon compte Mon Assistant Pro.\n\nCourriel du compte : \nDate de la demande : \n\nMerci de confirmer la suppression sous 30 jours.\n\n— "
  );

  return (
    <div className="min-h-screen bg-background" data-testid="data-deletion-page">
      <header className="hard-border-b px-8 py-6">
        <Link to="/" className="ticker text-muted-foreground hover:text-foreground" data-testid="back-home">← Mon Assistant Pro</Link>
      </header>
      <main className="max-w-3xl mx-auto px-8 py-16">
        <h1 className="font-display font-black text-5xl tracking-tight mb-2">Suppression des données</h1>
        <div className="ticker text-muted-foreground mb-12">User Data Deletion Instructions</div>

        <p className="text-base mb-8">
          Mon Assistant Pro respecte votre droit à la suppression complète de vos données conformément au
          <strong> RGPD</strong> (art. 17) et à la <strong>LPRPDE</strong> (Canada). Cette page explique comment demander cette suppression.
        </p>

        <div className="hard-border p-6 bg-secondary/30 mb-10" data-testid="quick-action">
          <div className="ticker text-muted-foreground mb-2">DEMANDE RAPIDE PAR COURRIEL</div>
          <p className="text-sm mb-4">
            Le moyen le plus rapide est d'envoyer un courriel à l'administrateur. Toutes les données associées à ton compte
            (profil, finances, athlètes, intégrations Meta/Google) seront supprimées sous 30 jours, et un courriel de confirmation
            te sera envoyé.
          </p>
          <a
            href={`mailto:impactkb.bjj@gmail.com?subject=${subject}&body=${body}`}
            className="inline-block bg-[#D90429] hover:bg-[#BF0424] text-white px-6 py-3 ticker transition-colors"
            data-testid="email-deletion-link"
          >
            Envoyer la demande par courriel →
          </a>
          <p className="text-xs text-muted-foreground mt-3 font-mono">
            ou écris directement à : impactkb.bjj@gmail.com
          </p>
        </div>

        <h2 className="font-display font-bold text-2xl mb-4 mt-12">Si tu as connecté Facebook / Instagram</h2>
        <ol className="list-decimal pl-6 space-y-3 text-base mb-10">
          <li>
            Connecte-toi à Facebook → <strong>Paramètres &amp; confidentialité</strong> → <strong>Paramètres</strong> →
            <strong> Applications et sites web</strong>.
          </li>
          <li>
            Trouve <em>« Mon Assistant Pro »</em> dans la liste et clique sur <strong>Supprimer</strong>.
            Facebook nous notifiera automatiquement et nos serveurs effaceront ton Page Access Token et toutes les
            données Meta liées sous 24 heures.
          </li>
          <li>
            Pour aller plus loin, demande aussi la suppression du compte Mon Assistant Pro lui-même via le formulaire ci-dessus.
          </li>
        </ol>

        <h2 className="font-display font-bold text-2xl mb-4 mt-12">Quelles données sont supprimées ?</h2>
        <ul className="list-disc pl-6 space-y-2 text-base mb-10">
          <li>Profil utilisateur (courriel, nom, paramètres)</li>
          <li>Données financières, fiscales et de redressement</li>
          <li>Athlètes, entrées santé et performances</li>
          <li>Articles de blog, messages de contact, projets, dossiers</li>
          <li>Tokens OAuth (Meta, Google, etc.) — révoqués immédiatement</li>
          <li>Journaux d'audit (après le délai légal de 12 mois)</li>
        </ul>

        <h2 className="font-display font-bold text-2xl mb-4 mt-12">Délai de suppression</h2>
        <p className="text-base mb-10">
          Les tokens d'API tiers sont révoqués <strong>sous 24 heures</strong>.
          Les données utilisateur sont effacées définitivement <strong>sous 30 jours</strong> (délai standard pour traiter les demandes manuelles et les sauvegardes).
        </p>

        <h2 className="font-display font-bold text-2xl mb-4 mt-12">Endpoint Meta automatique</h2>
        <p className="text-base">
          Pour les utilisateurs qui révoquent l'accès depuis Facebook, Mon Assistant Pro expose un callback automatique
          conforme aux exigences Meta (<code className="font-mono text-sm bg-secondary px-1.5 py-0.5">POST /api/meta/data-deletion-callback</code>) qui retourne
          un identifiant de confirmation et déclenche la suppression côté serveur sans intervention humaine.
        </p>

        <div className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground">
          Voir aussi : <Link to="/privacy-policy" className="text-[#D90429] underline">Politique de confidentialité</Link>
        </div>
      </main>
    </div>
  );
}
